import React from 'react';
// import isEmpty from 'lodash/isEmpty';
import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';

function FormCheckBox(props) {
    const { label = '' } = props;

    const {
        name = kebabCase(label),
        value = false,
        type = 'checkbox',
        path = '',
        groupClassName = '',
        inputClassName = '',
        onChange,
        readOnly,
        required = false
    } = props;

    const groupClasses = groupClassName ? `form-group ${groupClassName}` : 'form-group';
    
    const style = {
        marginTop: '.5rem'
    };

    return (
        <div className={`${groupClasses} form-check`} style={style}>
            <input
                id={name}
                name={name}
                type={type}
                className={inputClassName}
                checked={value}
                onChange={event => onChange(event.target.checked, path)}
                disabled={readOnly}
            /> 
            {required ? <span>*</span> : ''}
            <label htmlFor={name} className='form-check-label'>{label}</label>
        </div>
    );
}

FormCheckBox.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool,
    error: PropTypes.string,
    type: PropTypes.string,
    classes: PropTypes.string,
    groupClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    path: PropTypes.string,
    required: PropTypes.bool
};

export default FormCheckBox;
